<template lang="pug">
  .template-tools-container
    .template-tool.template-tool-move
      maximize-2-icon.icon-sm(style="transform:rotate(-45deg);")
    .template-tool.hover-danger(@click="$emit('delete')")
      trash-2-icon.icon-sm
</template>

<script>
export default {
}
</script>

<style lang="scss">
  @import '@/assets/colors.scss';

  .template-tools-container {
    width: 40px;
    height: 100%;
    padding: 0 5px;
    position: absolute;
    left: -40px;
    top: 0;

    .template-tool {
      color: $secondary;
      width: 30px;
      height: 30px;
      border-radius: 5px;
      background-color: transparent;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &.template-tool-move {
        cursor: move;
      }

      &:hover {
        color: $primary;
      }

      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }
  }
</style>
